import { Box } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { HomePanel } from '$scenes/router-panels/router-panels'
import { NAVIGATION_BAR_HEIGHT } from '$common/navigation-bar'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { StaticPanelWappId } from '$logic/wapp-panels'

export function Jaryan() {
  const navigate = useNavigate()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'jaryan'

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('jaryan')
      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )

  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>
        <StaticWappPanel wappId={StaticPanelWappId.JARYAN} />
      </Box>
    </VisibilityHandler>
  )
}
